import { useLocation, useNavigate } from 'react-router-dom';

export type QueryParams = Record<string, string | number | boolean | null | undefined>;

const useQueryParams = (defaultParams: QueryParams = {}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const parseValue = (value: string): string | number | boolean | null => {
    if (value === '') return '';
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (!isNaN(Number(value))) return Number(value);
    return value;
  };

  const getQueryParams = () => {
    const searchParams = new URLSearchParams(location.search);

    // Apply default parameters if they don't exist in the URL
    Object.keys(defaultParams).forEach((key) => {
      if (!searchParams.has(key)) {
        searchParams.set(key, String(defaultParams[key]));
      }
    });

    // Convert URLSearchParams to a plain object with correct types
    const params: QueryParams = {};
    searchParams.forEach((value, key) => {
      params[key] = parseValue(value);
    });

    return params;
  };

  const setQueryParams = (params: QueryParams) => {
    const searchParams = new URLSearchParams(location.search);

    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null) {
        searchParams.set(key, String(params[key]));
      } else {
        searchParams.delete(key);
      }
    });

    searchParams.set('time_request', String(Date.now()));

    navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
  };

  const clearQueryParams = () => {
    navigate(location.pathname, { replace: true });
  };

  return {
    getQueryParams,
    setQueryParams,
    clearQueryParams,
  };
};

export default useQueryParams;
